import {
    Component, ElementRef, Inject, Renderer2, ViewChild

} from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
 import { policyEngineActions } from '@src/store/reducers/policyEngineReducer';
// import { projectsActions } from '@src/store/reducers/projectsReducer';
// import {DialogManagerService } from '@src/services';
 import { Store } from '@src/store';
import { MatSort } from '@angular/material/sort';
import { TranformtionImpactServerClientFilterObjectService } from '@src/services'; 



export interface IDeployedPackagesTable {
    packageName: string;
    scriptName: string;
    action: string;
    policyCategory: string;
    policyName: string;
    ruleName:any,
}

@Component({
    selector: 'impact-analysis-policy',
    template: require('./impact-analysis-policy.html'),
    styles: [require('./impact-analysis-policy.scss')]
})
export class ImpactAnalysisPolicyComponent {
    public projectId: any;
    public dplModeType: any;
    public environmentId: string;
    public policyEnums:any;
    public processData:any;
 
    



    // tslint:disable-next-line:variable-name

    public displayedColumns = ['packageName', 'scriptName', 'action', 'policyCategory', 'policyName','ruleName'];
    public dataSource = new MatTableDataSource<IDeployedPackagesTable>([]);
    @ViewChild(MatSort) public sort: MatSort;

    private pressed = false;
  //  private currentResizeIndex: number;
    private startX: number;
    private startWidth: number;
    private isResizingRight: boolean;
    private resizableMousemove: () => void;
    private resizableMouseup: () => void;

    @ViewChild(MatTable, { read: ElementRef }) private matTableRef: ElementRef;
    private columns: any[] = [
        { field: 'packageName', width: 100 },
        { field: 'scriptName', width: 300 },
        { field: 'action', width: 350 },
        { field: 'policyCategory', width: 300 },
        { field: 'policyName', width: 250 },
        { field: 'ruleName', width: 250 }
    ];

    constructor(
        private store: Store,
        @Inject('$state') private $state: any,
        @Inject('$stateParams') private $stateParams: any,
        @Inject('$filter') private $filter: any,
        private renderer: Renderer2,
      //  private dialogManagerService: DialogManagerService 
        private tranformtionImpactServerClientFilterObjectService: TranformtionImpactServerClientFilterObjectService
    ) {
    

    }

    // navigate to a diffrent locaiton (for example: specific package)
    public navigate(event: any, sref: any, params: any) {
        event.preventDefault();
        params.projectId = this.$stateParams.projectId;
        params.id = this.$stateParams.projectId;
        this.$state.go(sref, params);
    }

    public async ngOnInit() {
        this.policyEnums = await this.store.dispatch({type:policyEngineActions.GET_POLICIES_ACTIONS})
      
        this.processData = this.tranformtionImpactServerClientFilterObjectService.getNewjsonData(this.store.getState().project.impact_analysis, this.store.getState().enums,this.$stateParams.jobEnv,this.$filter('changeEnumJobNameToName'));

        const data = [];
        if(this.processData.policyResults){
            this.processData.policyResults.forEach((item) => {
                data.push({
                    packageName : item.PackageName,
                    scriptName:item.SourceSchemacriptName ,
                    action : this.convertActionToValue(item.Action),
                    policyCategory: item.PolicyCategory,
                    policyName : item.PolicyName,
                    ruleName : item.RuleName
                });
            });
            this.dataSource.data = data;
        }
      
    }


    convertActionToValue(action)
    {
        if(this.policyEnums.length !== 0 )
        {
            for (var obj of this.policyEnums) 
            {
                if (obj.Key == action) 
                {
                    return obj.Value;
                }
            }
        }
    }


    public ngAfterViewInit() {
        this.setTableResize(this.matTableRef.nativeElement.clientWidth);

    }
  private setTableResize(tableWidth: number) {
        let totWidth = 0;
        this.columns.forEach((column) => {
            totWidth += column.width;
        });
        const scale = (tableWidth - 5) / totWidth;
        this.columns.forEach((column) => {
            column.width *= scale;
            this.setColumnWidth(column);
        });
    }
    

    public onResizeColumn(event: any, index: number) {
        this.checkResizing(event, index);
       // this.currentResizeIndex = index;
        this.pressed = true;
        this.startX = event.pageX;
        this.startWidth = event.target.clientWidth;
        event.preventDefault();
        this.mouseMove(index);
    }


private checkResizing(event, index) {
        const cellData = this.getCellData(index);
        if ((index === 0) ||
            (Math.abs(event.pageX - cellData.right) < cellData.width / 2 && index !== this.columns.length - 1)) {
            this.isResizingRight = true;
        } else {
            this.isResizingRight = false;
        }
    }

    private getCellData(index: number) {
        const headerRow = this.matTableRef.nativeElement.children[0];
        const cell = headerRow.children[0].children[index];
        return cell.getBoundingClientRect();
    }

    private mouseMove(index: number) {
        this.resizableMousemove = this.renderer.listen('document', 'mousemove', (event) => {
            if (this.pressed && event.buttons) {
                const dx = (this.isResizingRight) ? (event.pageX - this.startX) : (-event.pageX + this.startX);
                const width = this.startWidth + dx;
               // if (this.currentResizeIndex === index && width > 50) {
                    this.setColumnWidthChanges(index, width);
               // }
            }
        });
        this.resizableMouseup = this.renderer.listen('document', 'mouseup', () => {
            if (this.pressed) {
                this.pressed = false;
           //     this.currentResizeIndex = -1;
                this.resizableMousemove();
                this.resizableMouseup();
            }
        });
    }

    private setColumnWidthChanges(index: number, width: number) {
        const orgWidth = this.columns[index].width;
        const dx = width - orgWidth;
        if (dx !== 0) {
            const j = (this.isResizingRight) ? index + 1 : index - 1;
            const newWidth = this.columns[j].width - dx;
            // if (newWidth > 50) {
                this.columns[index].width = width;
                this.setColumnWidth(this.columns[index]);
                this.columns[j].width = newWidth;
                this.setColumnWidth(this.columns[j]);
            // }
        }   
    }

    private setColumnWidth(column: any) {
        const columnEls = Array.from(document.getElementsByClassName(`mat-column-${column.field}`));
        columnEls.forEach((el: HTMLDivElement) => {
            const packageNameElement = Array.from(el.getElementsByClassName('dp-package-name'));
            if (packageNameElement && packageNameElement.length > 0) {
                const el1: HTMLElement = packageNameElement[0] as HTMLElement;
                el1.style.width = `${column.width}px`;
            }
            el.style.width = `${column.width}px`;
        });
    }

    // @HostListener('window:resize', ['$event'])
    public onResize() {
        this.setTableResize(this.matTableRef.nativeElement.clientWidth);
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/impact-analysis/impact-analysis-policy-ang7/impact-analysis-policy.ts